import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
  GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0,
  GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0,
} = therapyPlanningAction;

function* getTherapyPlanningDischargeDate_2_0(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0 });
    const response = yield call(
      therapyPlanningService.getDischargeDatesOfTherapyPlanning,
      payload?.payload
    );
    if (response?.status === 200) {
      yield put({
        type: GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0, payload: error });
  }
}

function* getTherapyPlanningDischargeDateSaga_2_0() {
  yield takeEvery(GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0, getTherapyPlanningDischargeDate_2_0);
}

export default getTherapyPlanningDischargeDateSaga_2_0;
